import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { get } from 'lodash';

import Title from './title';
import PaymentScheduleLink from '../containers/purchase-payments-schedule-link.container';
import { Time } from '../../components/Time';
import Payment from '../lib/payment';
import money, { Money, format } from '../lib/money';
import '../css/share-summary.css';

export const CURRENT_PAYMENT = 'current-payment';
export const TOTAL_PURCHASE = 'total-purchase';

class ShareSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      view: this.props.view || CURRENT_PAYMENT,
    };

    this.viewTotalPurchase = this.viewTotalPurchase.bind(this);
    this.viewCurrentPayment = this.viewCurrentPayment.bind(this);
  }

  getTitle() {
    if (this.props.title) return this.props.title;
    return (
      <FormattedMessage
        id="shareSummary.title"
        defaultMessage="Group summary"
      />
    );
  }

  getOrganizerShareAmount() {
    const { view } = this.state;
    const {
      organizerTotalShareAmount,
      organizerCurrentShareAmount,
      currencyCode,
    } = this.props;

    if (view === TOTAL_PURCHASE) return organizerTotalShareAmount || Money.zero(currencyCode);

    return organizerCurrentShareAmount;
  }

  getInviteesShare() {
    const { inviteesSize, inviteesShareAmount, contributionsShareAmount } = this.props;
    const { view } = this.state;

    if (view === TOTAL_PURCHASE) {
      return {
        amount: money(inviteesShareAmount),
        size: inviteesSize,
      };
    }

    return { amount: contributionsShareAmount, size: inviteesSize };
  }

  getPercentages() {
    const organizerAmount = this.getOrganizerShareAmount();
    const inviteeAmount = this.getInviteesShare().amount;
    const totalAmountCents = (organizerAmount.amountCents + inviteeAmount.amountCents) || 1;
    const organizerPercentage = (organizerAmount.amountCents / totalAmountCents) * 100;

    return {
      organizerPercentage,
      inviteePercentage: 100 - organizerPercentage,
    };
  }

  changeView(ev, view) {
    ev.preventDefault();
    ev.stopPropagation();
    this.props.onViewToggle(view);
    this.setState({ view });
  }

  shouldRenderPayments() {
    const payments = get(this.props, 'payments', []);
    if (payments.length <= 1) return false;

    return !!payments;
  }

  shouldRenderTabs() {
    return this.shouldRenderPayments();
  }

  viewTotalPurchase(ev) {
    this.changeView(ev, TOTAL_PURCHASE);
  }

  viewCurrentPayment(ev) {
    this.changeView(ev, CURRENT_PAYMENT);
  }

  isCurrentPayment() {
    return this.state.view === CURRENT_PAYMENT;
  }

  isTotalPurchase() {
    return this.state.view === TOTAL_PURCHASE;
  }

  renderCurrentPaymentViewTab() {
    return (
      <li className={`nav-item ${this.isCurrentPayment() ? 'active' : ''}`}>
        <a href="#current-payment" onClick={this.viewCurrentPayment}>
          <FormattedMessage
            id="shareSummary.tabs.currentPaymemt"
            defaultMessage="Current payment"
          />
        </a>
      </li>
    );
  }

  renderTotalPurchaseViewTab() {
    return (
      <li className={`nav-item ${this.isTotalPurchase() ? 'active' : ''}`}>
        <a href="#total-purchase" onClick={this.viewTotalPurchase}>
          <FormattedMessage
            id="shareSummary.tabs.totalPurchase"
            defaultMessage="Total purchase"
          />
        </a>
      </li>
    );
  }

  renderPaymentPercentageSegment(max) {
    return (payment, index) => {
      const hasLine = index < max - 1;
      const lineClassName = hasLine ? 'bordered' : '';
      const paddingLeft = index > 0 ? 'pl-0' : '';
      const paddingRight = index < max - 1 ? 'pr-0' : '';
      const paidStatus = Payment.isPaid(payment.status) ? 'paid' : '';
      const activeStatus = Payment.isActive(payment.status) ? 'active' : '';
      const colClassName = `
        payment-column float-left ${paddingLeft} ${paddingRight} ${paidStatus} ${activeStatus}
      `;
      const style = { width: `${payment.percentage}%` };
      const text = (
        <FormattedMessage
          id="shareSummary.paymentPercentage.title"
          defaultMessage="Payment {n} {date}"
          values={{ date: this.paymentDate(payment), n: index + 1 }}
        />
      );

      return (
        <div className={colClassName} key={`payment-${payment.id}`} style={style}>
          <p className="text-left small-print mb-0 pb-0 pl-2" title={text}>
            {text}
            {' '}
            <i className="fa fa-fx fa-check" />
          </p>
          <div className={lineClassName}><hr /></div>
        </div>
      );
    }
  }

  paymentDate(payment) {
    if (Payment.isPaid(payment.status)) {
      const date = payment.paidAt ? payment.paidAt : payment.submittedAt;
      const time = (<Time time={date} />);
      return (
        <FormattedMessage
          id='shareSummary.paymentPercentage.paidDate'
          defaultMessage='(paid {date})'
          values={{
            date: time,
          }}
        />
      );
    }

    if (Payment.isSent(payment.status)) {
      const date = payment.paidAt ? payment.paidAt : payment.submittedAt;
      const time = (<Time time={date} />);
      return (
        <FormattedMessage
          id='shareSummary.paymentPercentage.sentDate'
          defaultMessage='(sent {date})'
          values={{
            date: time,
          }}
        />
      );
    }

    const date = payment.dueDeadline ? <Time time={payment.dueDeadline} /> : 'now';

    return (
      <FormattedMessage
        id='shareSummary.paymentPercentage.date'
        defaultMessage='(due {date})'
        values={{ date }}
      />
    )

  }

  renderViewTabs() {
    if (!this.shouldRenderTabs()) return null;

    return (
      <nav className="navbar navbar-toggleable-md view-tabs pl-0 mb-3">
        <span className="cool-grey">
          <FormattedMessage
            id="shareSummary.tabs.see"
            defaultMessage="See:"
          />
        </span>
        <ul className="navbar-nav mr-auto">
          {this.renderCurrentPaymentViewTab()}
          {this.renderTotalPurchaseViewTab()}
        </ul>
      </nav>
    );
  }

  renderOrganizerShare() {
    const share = money(this.getOrganizerShareAmount());

    return (
      <div className="organizer-share mr-3">
        <p>
          <FormattedMessage
            id="shareSummary.organizerShare.yourShare"
            defaultMessage="Your share"
          />
          {' '}
          <strong>{format(share)}</strong>
        </p>
      </div>
    );
  }

  renderInviteesShare() {
    const { amount, size } = this.getInviteesShare();
    return (
      <div className="invitees-share">
        <p>
          <FormattedMessage
            id="shareSummary.otherContributionsShare"
            defaultMessage="{n} Other {n, plural, one {contribution} other {contributions}} {amount}"
            values={{
              n: size,
              amount: <strong>{format(amount)}</strong>,
            }}
          />
        </p>
      </div>
    );
  }

  renderPaymentStatusBar() {
    const { payments } = this.props;
    const { view } = this.state;
    if (!this.shouldRenderPayments()) return null;

    return (
      <div className={`payments-status row mb-3 ${view}`}>
        <div className="col-12">
          {payments.map(this.renderPaymentPercentageSegment(payments.length))}
        </div>
      </div>
    );
  }

  renderSummaryBar() {
    const { organizerPercentage, inviteePercentage } = this.getPercentages();
    return (
      <div className="progress contribution-share-bar">
        <div
          className="progress-bar organizer-share"
          role="progressbar"
          style={{ width: `${organizerPercentage}%` }}
        />
        <div
          className="progress-bar divider-share"
          role="progressbar"
          style={{ width: '2px' }}
        />
        <div
          className="progress-bar invitees-share"
          role="progressbar"
          style={{ width: `${inviteePercentage}%` }}
        />
      </div>
    );
  }

  renderPaymentsSchedule() {
    if (!this.props.showPaymentSchedule) return null;

    return (
      <div className="details-link">
        <PaymentScheduleLink namespace={this.props.namespace}/>
      </div>
    )
  }

  render() {
    return (
      <div className="share-summary pb-1">
        <Title text={this.getTitle()} className="mb-4 p-0" name="share-summary" bigger divider />
        {this.renderViewTabs()}
        {this.renderPaymentStatusBar()}
        {this.renderSummaryBar()}
        <div className="share-breakdown d-flex pt-3">
          {this.renderOrganizerShare()}
          {this.renderInviteesShare()}
          {this.renderPaymentsSchedule()}
        </div>
      </div>
    );
  }
}

ShareSummary.defaultProps = {
  organizerTotalShareAmount: null,
  organizerCurrentShareAmount: null,
  inviteesShareAmount: null,
  contributionsShareAmount: null,
  inviteesSize: null,
  payments: null,
  currentView: null,
  showPaymentSchedule: false,
  namespace: null,
  onViewToggle: () => {},
};

export default injectIntl(ShareSummary);



// WEBPACK FOOTER //
// ./src/desktop/components/share-summary.js